import React from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import { isEmptyString } from 'utils/helper';
import AnvilFormFillable, { FormFieldsData } from 'components/anvilFormFillable';
import SignedConsentFiles from 'components/common/SignedConsentFiles';
import Spinner from 'components/spinner/Spinner';
import { MultiMediaResponseDTO } from 'artifacts/dtos';
import { NormalizeFormTemplateMetaDataResponse } from 'types/normalizedFormTemplate';

type Props = {
  data?: NormalizeFormTemplateMetaDataResponse;
  loading: boolean;
  errorMessages: string;
  signedMultimedia?: MultiMediaResponseDTO;
  onSubmit: (formData: FormFieldsData) => void;
  compactSignedLayout?: boolean;
  notFoundMessage?: string;
  className?: string;
};

function ConsentFormFillable({
  data,
  loading,
  errorMessages,
  signedMultimedia,
  onSubmit,
  compactSignedLayout = false,
  notFoundMessage = 'This form is no longer here or has expired. Please ask your doctor\'s office for a new one.',
  className,
}: Props) {
  return (
    <div className={clsx(
      'text-md',
      className,
      { '!max-w-[500px] m-auto bg-white': compactSignedLayout && !isNil(signedMultimedia) },
    )}
    >
      {!isEmptyString(errorMessages) && (
        <p className="error-message">{errorMessages}</p>
      )}

      {!loading && !isNil(data?.formTemplates) && isNil(signedMultimedia) && (
        <AnvilFormFillable
          data={data?.formTemplates ?? []}
          onSubmit={onSubmit}
        />
      )}

      {loading && (
        <div className="flex justify-center items-center h-screen">
          <Spinner />
        </div>
      )}

      {isNil(data) && isNil(signedMultimedia) && isEmptyString(errorMessages) && !loading && (
        <div className="flex justify-center items-center h-screen">
          <p className="text-red-600">{notFoundMessage}</p>
        </div>
      )}

      {!isNil(signedMultimedia) && !loading && (
        <SignedConsentFiles signedMultimedia={signedMultimedia} />
      )}
    </div>
  );
}

export default ConsentFormFillable;
